exports.GROUP2 = [
  { g2id: 'Bidding', g2title: 'Bidding' },
  { g2id: 'Play', g2title: 'Play' }
]
